import React from "react";
import Flag from "../../Common/Components/Flag.jsx";
import HighlightableText from "../../Common/HighlightableText.jsx";
import SportsmenImage from "../../Common/Components/SportsmenImageNba.jsx";
import { FormattedMessage } from "react-intl";
import useYearGameAchievementsFormatter from "../../utils/useYearGameAchievementsFormatter.js";
import { useEffect } from "react";
import AchievementDetailsModal from "../../TeamDetails/Components/Modal/AchievementDetailsModal.jsx";
import { useState } from "react";
import moment from "moment";

const CSSTransitionGroup = ({ children }) => {
  //todo: use transition group instead
  return children;
};

const ResultDetailsTableTournament = ({ details, marked, onDetailsClick, current, result, game }) => {
  const {formattedAchievements, setAchievements, formattedTypes, setTypes, fetchFromMatch} = useYearGameAchievementsFormatter(game.id);
  
  const [selectedSides, setSelectedSides] = useState(null);

  const viewAchievementScores = async(sportsmanA, sportsmanB, rankingClassificationId, submatchId) => {
    fetchFromMatch(sportsmanA.sportsmanId, sportsmanB.sportsmanId, rankingClassificationId, submatchId);

    setSelectedSides({sideA: sportsmanA, sideB: sportsmanB});
  }

  const onAchievementsDetailsClose = () => {
    setAchievements(null);
    setTypes([]);
    setSelectedSides(null);
  }

  useEffect(() => {
  }, [formattedAchievements]);

  if (!details) return null;
  // CLASS NAME:
  // zw-table zw-table--dark-striped
  // zw-tbl result__details details-table--tournament -> orig
  return (
    <>
      <table className="zw-table zw-table--dark-striped">
        {details.map((detail, key) => (
          <ResultDetailTournament
            onDetailsClick={onDetailsClick}
            marked={marked}
            key={key}
            {...detail}
            result={result}
            game={game}
            onAchievementsClick={viewAchievementScores}
            current={current}
            rankingClassificationId={result.rankingClassificationId ? result.rankingClassificationId : 0}
          />
        ))}
      </table>

      <CSSTransitionGroup
        transitionName="transition-fade"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
        > 
        {
          formattedAchievements &&
          selectedSides ? (
            <AchievementDetailsModal 
              key="1" 
              achievements={formattedTypes}
              details={formattedAchievements} 
              game={game.name}
              onClose={onAchievementsDetailsClose}
              isSingleSportsman={false}
              sidesDetails={selectedSides}
            />
        ) : null}
      </CSSTransitionGroup>
    </>
  );
};

const ResultDetailTournament = ({ sideA, sideB, marked, onDetailsClick, onAchievementsClick, current, rankingClassificationId, matchGroupMeta }) => {
  

  // CLASS NAME:
  // calendar-match calendar-match--score zw-tooltip__trigger
  // match-result -> orig

  let submatchId = matchGroupMeta ? matchGroupMeta.submatchId : 0;

  return (
    <tbody className="calendar-match calendar-match--score zw-tooltip__trigger">
      <tr onClick={() => onAchievementsClick(sideA, sideB, rankingClassificationId, submatchId)}>
        <th>
          <TournamentTooltip sideA={sideA} sideB={sideB} />
        </th>
        <th>
          <FinishedStar finished={true} />
        </th>
      </tr>
      <ResultDetailTournamentSide
        marked={marked.indexOf(sideA.sportsmanId) !== -1}
        onDetailsClick={onDetailsClick}
        {...sideA}
      >
        {/* <TournamentTooltip sideA={sideA} sideB={sideB} /> */}
      </ResultDetailTournamentSide>
      <ResultDetailTournamentSide
        marked={marked.indexOf(sideB.sportsmanId) !== -1}
        onDetailsClick={onDetailsClick}
        {...sideB}
      />
    </tbody>
  );
};
const ResultDetailTournamentSide = ({
  name,
  result,
  country,
  imageSrc,
  sportsmanId,
  marked,
  onDetailsClick,
  children,
}) => {
  return (
    <tr>
      <td>
        {children}
        {imageSrc ? (
          <SportsmenImage name={name} imageSrc={imageSrc} />
        ) : (
          <Flag code={country} />
        )}
        <HighlightableText active={marked}>{name}</HighlightableText>
      </td>
      <td
        style={{ cursor: "pointer", color: "#82bc3d", fontWeight: "bold" }}
        onClick={() => onDetailsClick(sportsmanId)}
      >
        {result}
      </td>
    </tr>
  );
};
const TournamentTooltip = ({ sideA, sideB }) => {
  if (!sideA.details && !sideB.details) {
    return null;
  }
  return (
    <div className="zw-tooltip">
      <div className="match-result__details-tooltip zw-tooltip__content">
        <div className="match-result__side">
          <div className="match-result__sportsmen">
            <Flag code={sideA.country} />
            <span>{sideA.nameShort}</span>
          </div>
          <div className="match-result__details">{sideA.details}</div>
        </div>
        <div className="match-result__side">
          <div className="match-result__sportsmen">
            <Flag code={sideB.country} />
            <span>{sideB.nameShort}</span>
          </div>
          <div className="match-result__details">{sideB.details}</div>
        </div>
      </div>
    </div>
  );
};

const FinishedStar = ({ finished }) =>
!finished ? null : (
  <FormattedMessage id="calendar.finished">
    {(msg) => (
      <span
        title={msg}
        className="glyphicon glyphicon-star match-calendar__star"
      />
    )}
  </FormattedMessage>
);

export default ResultDetailsTableTournament;
